export const SELECTION_PADDING = 14;
